import { Observable } from 'rxjs';
// #Time;
// Upv1;Upv2;Upv3;Upv4;Upv5;Upv6;Upv7;Upv8;Upv9;Upv10;Upv11;Upv12;
// Ipv1;Ipv2;Ipv3;Ipv4;Ipv5;Ipv6;Ipv7;Ipv8;Ipv9;Ipv10;Ipv11;Ipv12;
// Uac1;Uac2;Uac3;
// Iac1;Iac2;Iac3;
// Status;Error;Temp;cos;fac;Pac;Qac;Eac;Cycle Time
export interface InvertersValue {
  dt: string;
  Upv1: number; // Input Voltage (V):
  Upv2: number;
  Upv3: number;
  Upv4: number;
  Upv5: number;
  Upv6: number;
  Upv7: number;
  Upv8: number;
  Upv9: number;
  Upv10: number;
  Upv11: number;
  Upv12: number;
  Ipv1: number; // Input Current (A):
  Ipv2: number;
  Ipv3: number;
  Ipv4: number;
  Ipv5: number;
  Ipv6: number;
  Ipv7: number;
  Ipv8: number;
  Ipv9: number;
  Ipv10: number;
  Ipv11: number;
  Ipv12: number;
  Uac1: number; // Grid Voltage(V)
  Uac2: number;
  Uac3: number;
  Iac1: number; // Grid Current(A)
  Iac2: number;
  Iac3: number;
  Status: number;
  Error: number;
  Temp: number;
  cos: number; // Power Factor
  fac: number; // Grid Frequency (Hz):
  Pac: number; // Active Power(kW)
  Qac: number; // Reactive Power (kVar)
  Eac: number; // ??
  CycleTime: number;
}

export interface ActivePowerValue {
  dt: string;
  Pac: number;
}

export abstract class InvertersData {
  abstract getInverterTodayData(num: number): Observable<InvertersValue[]>;
}
